module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._l((_vm.produtos), function(p, iProd) {
    return _c('div', {
      staticClass: "produtos"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('h4', [_vm._v("Nome")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (p.nome),
        expression: "p.nome"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (p.nome)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(p, "nome", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.nome === '') ? _c('label', [_vm._v("*Campo Obrigatório")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('h4', [_vm._v("Imagem ")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": ("file-input-" + iProd)
      }
    }), _vm._v(" "), _c('p', {
      attrs: {
        "id": "status"
      }
    }, [_vm._v("Please select a file")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('h4', [_vm._v("Descrição")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (p.descricao),
        expression: "p.descricao"
      }],
      staticClass: "form-control",
      attrs: {
        "rows": "1",
        "cols": "12"
      },
      domProps: {
        "value": (p.descricao)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(p, "descricao", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.descricao === '') ? _c('label', [_vm._v("*Campo Obrigatório")]) : _vm._e()])]), _vm._v(" "), _vm._l((p.formularioPreco), function(linha, index) {
      return _c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-md-3"
      }, [_c('h4', [_vm._v("Preço")]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (linha.preco),
          expression: "linha.preco"
        }, {
          name: "money",
          rawName: "v-money",
          value: (_vm.money),
          expression: "money"
        }],
        staticClass: "form-control currency",
        attrs: {
          "value": "0",
          "min": "0",
          "step": "0.01",
          "data-number-to-fixed": "2",
          "data-number-stepfactor": "100"
        },
        domProps: {
          "value": (linha.preco)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(linha, "preco", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-md-3"
      }, [_c('h4', [_vm._v("Categoria")]), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (linha.id_cardapio),
          expression: "linha.id_cardapio"
        }],
        staticClass: "form-control",
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(linha, "id_cardapio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.categories), function(c) {
        return _c('option', {
          domProps: {
            "value": c.id
          }
        }, [_vm._v(_vm._s(c.nome))])
      }), 0), _vm._v(" "), _c('label', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (linha.id_cardapio === 0),
          expression: "linha.id_cardapio===0"
        }]
      }, [_vm._v("*Campo Obrigatório")])]), _vm._v(" "), (index === 0) ? _c('div', {
        staticClass: "col-md-3 adicionaPreco"
      }, [_c('a', {
        on: {
          "click": function($event) {
            return _vm.adicionaPreco(iProd)
          }
        }
      }, [_vm._v("Adicionar Preço")])]) : _c('div', {
        staticClass: "col-md-3 adicionaPreco"
      }, [_c('a', {
        on: {
          "click": function($event) {
            return _vm.removerPreco(index, iProd)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-times",
        attrs: {
          "aria-hidden": "true"
        }
      })])])])
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-1"
    }, [_c('h4', [_vm._v("Ativo")]), _vm._v(" "), _c('toggle-button', {
      attrs: {
        "color": _vm.color,
        "sync": true
      },
      model: {
        value: (p.ativo),
        callback: function($$v) {
          _vm.$set(p, "ativo", $$v)
        },
        expression: "p.ativo"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('h4', [_vm._v("Produtos permite adicionais")]), _vm._v(" "), _c('toggle-button', {
      attrs: {
        "sync": true
      },
      model: {
        value: (p.permiteadicionais),
        callback: function($$v) {
          _vm.$set(p, "permiteadicionais", $$v)
        },
        expression: "p.permiteadicionais"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-2",
      staticStyle: {
        "padding": "0.7em"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.removerProduto(iProd)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (p.permiteadicionais),
        expression: "p.permiteadicionais"
      }],
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('h4', [_vm._v("Categoria adicionais")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (p.adicional),
        expression: "p.adicional"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(p, "adicional", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.categories), function(c) {
      return _c('option', {
        domProps: {
          "value": c.id
        }
      }, [_vm._v(_vm._s(c.nome))])
    }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br')], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 adicionaVoo",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    on: {
      "click": _vm.adicionarCategoria
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("Adicionar Categoria")])])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/produtos"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.habilitaGravar),
      expression: "habilitaGravar"
    }],
    staticClass: "btn btn-success",
    on: {
      "click": _vm.gravar
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }, [_vm._v("  Gravar")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-success"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("  Gravando")])], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9fc3bc8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/InclusaoRapida/InclusaoRapidaProdutos.vue
// module id = 1285
// module chunks = 1